export default {"src":"/_next/static/media/no-third-party.d73624a4.svg","height":57,"width":58};